export default "<p>paiement-list works!</p>\r\n"